import { getLinesToFillScreen } from '../utils';
import inquirer from 'inquirer';

export async function requestPaths(root: string) {
  console.clear();
  const baseDir = root ?? process.cwd();
  console.log(baseDir);
  const result: { podDirectory: string } = await inquirer.prompt({
    name: 'podDirectory',
    type: 'file-tree-selection',
    message: 'Choose a directory (Up/Down to navigate, Right/Left to open/close directories)',
    // onlyShowDir: true,
    // hideRoot: true,
    // multiple: true,
    root: 'app/pods',
    // pageSize: getLinesToFillScreen(),
  });

  console.log(result);
}
